import { StatusBar, StyleSheet, Text, View } from "react-native";
import React, { useEffect } from "react";
import IsicLogoSplash from "../../../assets/images/splashscreen/isicLogoSplash";
import SecondPartLogo from "../../../assets/images/splashscreen/subpart";
import Animated, {
	Easing,
	useAnimatedStyle,
	useSharedValue,
	withDelay,
	withSpring,
	withTiming,
} from "react-native-reanimated";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getPrimaryColor } from "../../utils/ColorsFunctions";
import { SplashScreenProps } from "./BoardingStack";

const SplashScreen = ({ navigation }: SplashScreenProps) => {
	const scale = useSharedValue(1.5);
	const logoPosition = useSharedValue(51);
	const secondLogoOpacity = useSharedValue(0);
	const user = useAppSelector(s => s.auth.subUser!);
	const secondLogoStyle = useAnimatedStyle(() => {
		return {
			opacity: withDelay(
				1000,
				withTiming(secondLogoOpacity.value, {
					duration: 1200,
					easing: Easing.ease,
				})
			),
		};
	});
	const logoAnimation = useAnimatedStyle(() => {
		return {
			transform: [
				{
					scale: withDelay(1000, withSpring(scale.value, { mass: 3 })),
				},
				{
					translateX: withDelay(1250, withSpring(logoPosition.value)),
				},
			],
		};
	});
	useEffect(() => {
		scale.value = 1;
		logoPosition.value = 0;
		secondLogoOpacity.value = 1;
		setTimeout(() => {
			navigation.navigate("OnBoarding");
		}, 2500);
	}, []);
	return (
		<View style={[styles.root, { backgroundColor: getPrimaryColor(user) }]}>
			<StatusBar backgroundColor={getPrimaryColor(user)} />
			<Animated.View style={[styles.logo, logoAnimation]}>
				<IsicLogoSplash />
			</Animated.View>
			<Animated.View style={secondLogoStyle}>
				<SecondPartLogo style={styles.text} />
			</Animated.View>
		</View>
	);
};

export default SplashScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
	},
	logo: {
		marginRight: 10,
	},
	text: {},
});
